const createProductMediaSlider = () => {
    new Swiper('.product-media', {
        slidesPerView: 1,
        loop: true,
        navigation: {
            prevEl: ".product-media-prev",
            nextEl: ".product-media-next",
        },
        pagination: {
            el: ".product-media-pagination",
            clickable: false,
        },
        breakpoints: {
            640: {
                slidesPerView: 1.5,
            },
            1024: {
                slidesPerView: 2.5,
            }
        }
    });
}

createProductMediaSlider();
document.addEventListener("shopify:section:load", createProductMediaSlider);